import styled from "styled-components";

export const BoardContainer = styled.div`
  padding: 24px;
  background: var(--background);
  min-height: 100vh;

  @media (max-width: 600px) {
    padding: 16px;
  }
`;

export const GlobalHeader = styled.header`
  margin-bottom: 32px;

  .logo-area {
    display: flex;
    align-items: center;
    gap: 12px;
    h1 {
      font-size: 26px;
      color: var(--text-main);
      font-weight: 800;

      @media (max-width: 480px) {
        font-size: 20px; 
      }
    }
  }
`;

export const ColumnsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  align-items: start;

  @media (max-width: 1024px) {
    gap: 16px;
  }


  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Column = styled.div`
  background: var(--border); 
  border-radius: var(--radius-md);
  padding: 20px;
  min-height: 70vh;
  transition: all 0.3s ease;

  @media (max-width: 600px) {
    padding: 12px;
    min-height: auto;
`;

export const ColumnHeader = styled.h2`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 700;
  color: ${(props) => props.color || "var(--text-main)"};
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.05);

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

export const OrderList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: 16px;
  font-weight: 500;
  color: var(--text-secondary);
  text-align: center;
  padding: 20px;
`;
